import { NavLink } from 'react-router';
import { twMerge } from 'tailwind-merge';

import { SvgIcon } from '@crm/shared/ui';

import type { TSvgIcon } from '@crm/shared/model/SvgIcon.type';

interface IMenuLink {
    textContent: string;
    toHref: string;
    icon: TSvgIcon | string;
}

export const MenuLink = ({ textContent, toHref, icon }: IMenuLink) => (
    <NavLink
        className="group flex flex-col items-center justify-center"
        to={toHref}
        state={{ fromAppMenu: true }}
    >
        {({ isActive }) => (
            <>
                <span className={twMerge('rounded-lg bg-white p-2')}>
                    {typeof icon === 'string' ? (
                        <img
                            aria-hidden
                            alt=""
                            className="h-[50px] w-[51px] object-contain"
                            src={icon}
                        />
                    ) : (
                        <SvgIcon
                            icon={icon}
                            className={twMerge(
                                'size-12.5 text-slate-500',
                                isActive && 'text-white'
                            )}
                        />
                    )}
                </span>
                <span
                    className={twMerge(
                        'text-center text-xs leading-4 font-normal whitespace-pre-line text-smtr-main-tertiary-100 transition-colors group-hover:text-smtr-main-black-100',
                        isActive && 'font-medium text-smtr-main-black-100'
                    )}
                >
                    {textContent}
                </span>
            </>
        )}
    </NavLink>
);
